import { UNASSIGNED_SALES_METRO_ID } from '../enums';

/**
 * @param {import('../types/SalesMetro.api').ISalesMetroApiModel} model
 * @returns {import('../types/SalesMetro').ISalesMetro}
 */
export const toSalesMetro = (model) => ({
  id: model.id,
  name: model.name ?? '',
  assignedInternalUserIds: model.assignedInternalUserIds ?? [],
});

/**
 * Maps a page of API rows to sales metros, dropping the reserved "Unassigned"
 * row and any row without an id.
 *
 * The reserved row is a placeholder, not a territory: its all-zeros id is one
 * the monolith cannot resolve, so a filter or field carrying it matches nothing.
 * "Nobody assigned" is the `'unassigned'` option value instead.
 *
 * @param {import('../types/SalesMetro.api').ISalesMetroApiModel[]} items
 * @returns {import('../types/SalesMetro').ISalesMetro[]}
 */
export const toSalesMetros = (items) =>
  (items || [])
    .filter((model) => model?.id && model.id !== UNASSIGNED_SALES_METRO_ID)
    .map(toSalesMetro);

export const SalesMetroAdapters = {
  toSalesMetro,
  toSalesMetros,
};
